export default function formatCurrency(
    amount: number,
    currency: string = 'ZAR',
): string {
    const currencyToUse = (currency ?? 'ZAR').trim().toUpperCase() || 'ZAR';

    let safeCurrency = currencyToUse;
    try {
        new Intl.NumberFormat('en', {
            style: 'currency',
            currency: currencyToUse,
        }).format(0);
    } catch {
        safeCurrency = 'ZAR';
    }

    return new Intl.NumberFormat('en', {
        style: 'currency',
        currency: safeCurrency,
    }).format(amount);
}
